import React, { FC, useContext } from 'react'

import { styled } from '@linaria/react'
import { Property } from 'csstype'

import { breakpoints } from 'components/designSystem/shared/breakpoints'

import { ParentCommon } from './Buttons/buttons.styled'
import { Chat } from './Buttons/Chat'
import { Like } from './Buttons/Like'
import { UnionButtons } from './Buttons/UnionButtons'
import { isVoteable } from './function/isVoteable'
import { ProfileNextContext } from '../Profile/ProfileMain/context/ProfileNextContext'

/**
 * Только для пользователей которые неавторизованный, и только для анкеты
 */
export const MobileNotAuthorized: FC = () => {
  const { place, voteable } = useContext(ProfileNextContext)
  const isAlignRight = place === 'profile' && !voteable
  const hasVoted = isVoteable(place, voteable)

  return (
    <Parent
      $align={isAlignRight ? 'flex-end' : 'space-between'}
      data-name="control-bar-mobile"
    >
      {hasVoted && <Chat />}
      <UnionButtons>
        {!hasVoted && <Chat />}
        {hasVoted && <Like />}
      </UnionButtons>
    </Parent>
  )
}

const Parent = styled(ParentCommon)<{ $align: Property.JustifyContent }>`
  display: none;
  grid-auto-flow: column;
  justify-content: ${(props) => props.$align};
  align-items: center;

  @media screen and (max-width: ${breakpoints.mobile}px) {
    display: grid;
  }
`
